
export enum OrigemDadoColetadoEnum {
  TarefaRoteiro = 'TarefaRoteiro',
  AposCheckin = 'AposCheckin',
  AntesCheckout = 'AntesCheckout',
  Questionario = 'Questionario',
}
